export default __webpack_public_path__ + "static/media/photo-6.a4f91ca2.jpg";